import { render, staticRenderFns } from "./Weekend.vue?vue&type=template&id=25e44b48&"
import script from "./Weekend.vue?vue&type=script&lang=js&"
export * from "./Weekend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports